import { useEffect } from "react";

const defaultTitle = "Epic-Jobs | Moving Careers and Companies Forward";
const defaultDescription = "Epic-Jobs connects candidates and employers through job postings, applications, profiles, and hiring tools.";

const setMeta = (name, content) => {
  if (!content) return;

  let tag = document.querySelector(`meta[name="${name}"]`);

  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("name", name);
    document.head.appendChild(tag);
  }

  tag.setAttribute("content", content);
};

const Seo = ({ title = defaultTitle, description = defaultDescription }) => {
  useEffect(() => {
    document.title = title;
    setMeta("description", description);
  }, [description, title]);

  return null;
};

export default Seo;
